export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-07.0c135217.png";